import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../_config';

@Injectable({providedIn: 'root'})
export class SitemapService {
  constructor(private http: HttpClient) {
  }

  getSitemap() {
    return this.http.get<any>(AppConfig.API_ENDPOINT + `/sitemap`);
  }
}
